import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import {Row, Col, Container} from 'reactstrap';
import {CollapseItemTableIndicator} from "../../comum/components/CollapseItemTableIndicator";
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingImage from "../../comum/components/LoadingImage";
import DetalhesServico from "./DetalhesServicos";
import { HeaderTableFixed } from "../../../utils/headerTableFixed";

@inject("store")
@observer
export class TabelaAcompServicos extends Component{

    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;

        this.controller = this.props.controller;
        
        window.addEventListener('scroll', HeaderTableFixed);
    };

    render() {
        const detalhesRow = {
            renderer: row => (
                <Row>
                    <DetalhesServico titulo="Outros dados" colunas={this.controller.colunas} row={row}/>
                </Row>
            ),
            showExpandColumn: true,
            expandByColumnOnly: true,
            expandHeaderColumnRenderer: () => "Detalhes",
            onExpandAll: (isExpandAll, results, e) => {
                e.PreventDefault();
            },
            expandColumnPosition: 'right',
            expandColumnRenderer: ({ expanded }) => {
                return (
                    <CollapseItemTableIndicator expanded={expanded}/>
                );
            }
        };

        return (
            <Container fluid className="tabela-container">
                { this.controller.loading ? <LoadingImage/>

                : <React.Fragment>
                    { (!this.controller.servicosLista.length>0)
                        ? <Row>
                            <Col xs={12}>
                                <span className="mensagem-filtrar">
                                    {this.controller.tableMessage}
                                </span>
                            </Col>
                        </Row>
                        :

                        <InfiniteScroll
                            dataLength = {this.controller.items.length}
                            next = {() => this.controller.loadNextTurn()}
                            loadder = {<span>Carregando....</span>}
                            hasMore = {this.controller.hasMore}
                            loader = {<LoadingImage/>}
                        >
                            <ToolkitProvider
                                keyField="OsId"
                                data={[...this.controller.items]}
                                columns={[...this.controller.colunas]} >
                                {props => (
                                    <div id="tableHeaderFixed" className="tabela-overflow">
                                    <BootstrapTable bootstrap4
                                                    striped
                                                    bordered={false}
                                                    noDataIndication={() => this.controller.noData}
                                                    classes="tabela tabela-layout cabotagem"
                                                    expandRow={detalhesRow}
                                                    {...props.baseProps} />
                                </div>)
                                }
                            </ToolkitProvider>
                        </InfiniteScroll> }
                </React.Fragment> }
            </Container>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/acompanhamentoservico/components/TabelaAcompServicos.js